import { createFileRoute } from '@tanstack/react-router'
import { PublicReschedulePage } from '../../modules/bookings/public-manage-booking'

export const Route = createFileRoute('/booking/$id/reschedule')({
  component: RescheduleRoute,
})

function RescheduleRoute() {
  const { id } = Route.useParams()
  return <PublicReschedulePage bookingId={id} />
}
